var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-box"},[_c('editor',{key:_vm.timymceFlag,attrs:{"init":_vm.init},model:{value:(_vm.tinymce_value),callback:function ($$v) {_vm.tinymce_value=$$v},expression:"tinymce_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }